import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@this/src/components/shared/ui/data_displays/table';
import type HotelOrderItemAgodaTotal from '@this/src/domain/arrangement/hotel_order_item_agoda_total';
import type Arranger from '@this/src/domain/arranger/arranger';
import TotalTableRow from './total_table_row';

interface Props {
  hotelOrderItemAgodaTotals: HotelOrderItemAgodaTotal[];
  arrangers: Arranger[];
  currentArranger: Arranger | null;
  suppliedItemId: number | null;
}

const TotalResultTable: React.FC<Props> = ({
  hotelOrderItemAgodaTotals,
  arrangers,
  currentArranger,
  suppliedItemId
}) => {
  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>予約日</TableCell>
          <TableCell align="right">HotelElement件数</TableCell>
          <TableCell align="right">卸値の件数</TableCell>
          <TableCell align="right">Agoda予約の件数</TableCell>
          <TableCell align="right">代金詳細の合計金額</TableCell>
          <TableCell align="right">卸値の合計金額</TableCell>
          <TableCell align="right">Agoda予約の合計金額</TableCell>
          <TableCell>完全一致</TableCell>
          <TableCell>Hotel Element CSV</TableCell>
          <TableCell>Agoda CSV</TableCell>
          <TableCell>総数確認日</TableCell>
          <TableCell>総数確認者</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {hotelOrderItemAgodaTotals.map(hotelOrderItemAgodaTotal => (
          <TotalTableRow
            key={hotelOrderItemAgodaTotal.reservationDate.format('YYYY-MM-DD')}
            hotelOrderItemAgodaTotal={hotelOrderItemAgodaTotal}
            arrangers={arrangers}
            currentArranger={currentArranger}
            suppliedItemId={suppliedItemId}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default TotalResultTable;
